import { render, staticRenderFns } from "./TicketDetailDialog.vue?vue&type=template&id=23f29505"
import script from "./TicketDetailDialog.vue?vue&type=script&lang=js"
export * from "./TicketDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports